import WeakMap from './_WeakMap.js';

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

export default metaMap;



//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/~/lodash-es/_metaMap.js
// module id = 1571
// module chunks = 0